import {
  Badge,
  Box,
  Button,
  ComboboxData,
  CopyButton,
  Flex,
  Group,
  LoadingOverlay,
  NumberInput,
  Select,
  Switch,
  Text,
  TextInput,
  Textarea,
  Tooltip,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconCheck, IconEyeSearch, IconX } from "@tabler/icons-react";
import React, { useEffect, useState } from "react";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { handleEditProductNew } from "../../../../api/ApiProduct";
import { getDataBrandV2 } from "../../../../api/ApiSell";
import ButtonClose from "../../../../common/ButtonClose/ButtonClose";
import OpenProductTab from "../../../../components/ProductTabs/OpenProductTab";
import { ProductUpdateItem } from "../../../../model/ModelProductNew";
import { useProductCreateStore } from "../../../../store/useProductCreateStore";
import { handleShowErrorValidate } from "../helper";
import { useNavigate } from "react-router-dom";

const ItemCommand = () => {
  const navigate = useNavigate();
  const dataItemBase = useProductCreateStore((state) => state.dataItemBase);
  const setDataItemBase = useProductCreateStore(
    (state) => state.setDataItemBase,
  );
  const [dataOptionBrand, setDataOptionBrand] = useState<ComboboxData>();
  const [dataListErrorValidate, setDataListErrorValidate] =
    useState<string[]>();
  const [visible, { toggle, open, close }] = useDisclosure(false);
  const [summary, setSummary] = useState("");
  const hacomUrl = process.env.REACT_APP_BASE_WEB_HACOM_URL;

  const colorOptions = [
    { value: "red", label: "Red" },
    { value: "blue", label: "Blue" },
    { value: "yellow", label: "Yellow" },
    { value: "green", label: "Green" },
    { value: "black", label: "Black" },
    { value: "purple", label: "Purple" },
    { value: "orange", label: "Orange" },
    { value: "pink", label: "Pink" },
  ];
  const [modal, setModel] = useState("");
  const [isOpenUpdateTechnical, setIsOpenUpdateTechnical] = useState(false);

  // call api lấy dữ liệu thương hiệu
  const fetDataBrand = async (keySearch?: string) => {
    try {
      let url = "?Skip=0&Take=1000";
      if (keySearch) {
        url += `&KeySearch=${keySearch}`;
      }
      const response = await getDataBrandV2(url);
      if (response && response.data.lists) {
        const formattedData = response.data.lists
          .filter((i: any) => i.id && i.name)
          .map((item: any, index: number) => ({
            value: item.id.toString(),
            label: item.name,
          }));
        setDataOptionBrand(formattedData);
      }
    } catch (error) {
      console.log("error fetchDataBrand", error);
    }
  };

  const validateField = (
    label: string,
    value: any,
    dataItemBase: any,
  ): string[] => {
    const errors: string[] = [];

    // Validate giá bán
    // if (label === "unitSellingPrice" && (!value || value <= 0)) {
    //   errors.push("unitSellingPrice");
    // }

    // // Validate giá thị trường
    // if (label === "marketPrice" && (!value || value <= 0)) {
    //   errors.push("marketPrice");
    // }
    // if (
    //   label === "marketPrice" &&
    //   Number(dataItemBase?.marketPrice) !== 0 &&
    //   Number(dataItemBase?.marketPrice || 0) <
    //     Number(dataItemBase?.unitSellingPrice || 0)
    // ) {
    //   errors.push("marketPriceInvalid");
    // }

    // Validate tên sản phẩm
    if (label === "itemName" && !value) {
      errors.push("itemName");
    }

    // // Validate mã sản phẩm
    // if (label === "itemCode" && !value) {
    //   errors.push("itemCode");
    // }

    // Validate Link sản phẩm
    if (label === "url" && !value) {
      errors.push("url");
    }

    // Validate Meta Title
    if (label === "metaTitle" && !value) {
      errors.push("metaTitle");
    }

    // Validate Meta Keyword
    if (label === "metaKeyword" && !value) {
      errors.push("metaKeyword");
    }

    // Validate Meta Description
    // if (label === "metaDescription" && !value) {
    //   errors.push("metaDescription");
    // } else if (label === "metaDescription" && countCharacters(value) > 160) {
    //   errors.push("metaDescription");
    // }

    return errors;
  };

  const handleChangeValue = (value: any, label: string) => {
    // console.log("handleChangeValue", value, label);
    // // Cập nhật giá trị trong dataItemBase
    // setDataItemBase({
    //   ...dataItemBase,
    //   [label]: value,
    // });

    // // Kiểm tra lỗi cho trường hiện tại
    // const fieldErrors = validateField(label, value, dataItemBase);

    // Cập nhật giá trị trong dataItemBase
    const updatedDataItemBase = {
      ...dataItemBase,
      [label]: value,
    };
    setDataItemBase(updatedDataItemBase);

    // Kiểm tra lỗi cho trường hiện tại với giá trị mới
    const fieldErrors = validateField(label, value, updatedDataItemBase);

    setDataListErrorValidate((prev) => {
      // Xóa lỗi cũ liên quan đến trường hiện tại
      const updatedErrors =
        prev?.filter((error) => !error.startsWith(label)) || [];
      // Thêm lỗi mới nếu có
      return [...updatedErrors, ...fieldErrors];
    });
  };
  const handleSubmitForm = async () => {
    // let dataSubmit: ProductUpdateItem = {
    //   cssClassStatus: dataItemBase?.cssClassStatus ?? "",
    //   orgId: dataItemBase?.orgId ?? 0,
    //   id: dataItemBase?.id ?? 0,
    //   parentId: dataItemBase?.parentId ?? 0,
    //   barcode: dataItemBase?.barcode ?? "",
    //   itemCode: dataItemBase?.itemCode ?? "",
    //   itemName: dataItemBase?.itemName ?? "",
    //   itemCost: dataItemBase?.itemCost ?? 0,
    //   inUse: dataItemBase?.inUse ?? "",
    //   barcodeUsed: dataItemBase?.barcodeUsed ?? "",
    //   shortName: dataItemBase?.shortName ?? "",
    //   discountValue: dataItemBase?.discountValue ?? 0,
    //   warrantyByPartner: dataItemBase?.warrantyByPartner ?? "",
    //   warrantyByCus: dataItemBase?.warrantyByCus ?? "",
    //   vat: dataItemBase?.vat ?? 0,
    //   isPromotional: dataItemBase?.isPromotional ?? "",
    //   accessory: dataItemBase?.accessory ?? "",
    //   fullModelCode: dataItemBase?.fullModelCode ?? "",
    //   profit: dataItemBase?.profit ?? 0,
    //   categoryId: dataItemBase?.categoryId ?? 0,
    //   createdBy: dataItemBase?.createdBy ?? "",
    //   lastUpdateDate: dataItemBase?.lastUpdateDate ?? "",
    //   lastUpdatedBy: dataItemBase?.lastUpdatedBy ?? "",
    //   lastUpdateLogin: dataItemBase?.lastUpdateLogin ?? "",
    //   creationDate: dataItemBase?.creationDate ?? "",
    //   attribute1: dataItemBase?.attribute1 ?? "",
    //   attribute2: dataItemBase?.attribute2 ?? "",
    //   attribute3: dataItemBase?.attribute3 ?? "",
    //   attribute4: dataItemBase?.attribute4 ?? "",
    //   attribute5: dataItemBase?.attribute5 ?? "",
    //   attribute6: dataItemBase?.attribute6 ?? "",
    //   attribute7: dataItemBase?.attribute7 ?? "",
    //   attribute8: dataItemBase?.attribute8 ?? "",
    //   attribute9: dataItemBase?.attribute9 ?? "",
    //   attribute10: dataItemBase?.attribute10 ?? "",
    //   attribute11: dataItemBase?.attribute11 ?? "",
    //   attribute12: dataItemBase?.attribute12 ?? "",
    //   attribute13: dataItemBase?.attribute13 ?? "",
    //   attribute14: dataItemBase?.attribute14 ?? "",
    //   attribute15: dataItemBase?.attribute15 ?? "",
    //   erpInventoryItemId: dataItemBase?.erpInventoryItemId ?? 0,
    //   marketPrice: dataItemBase?.marketPrice ?? 0,
    //   unitWeight: dataItemBase?.unitWeight ?? 0,
    //   weightUomCode: dataItemBase?.weightUomCode ?? "",
    //   volumeUomCode: dataItemBase?.volumeUomCode ?? "",
    //   unitVolume: dataItemBase?.unitVolume ?? 0,
    //   primaryUomCode: dataItemBase?.primaryUomCode ?? "",
    //   primaryUnitOfMeasure: dataItemBase?.primaryUnitOfMeasure ?? "",
    //   dimensionUomCode: dataItemBase?.dimensionUomCode ?? "",
    //   unitLength: dataItemBase?.unitLength ?? 0,
    //   unitWidth: dataItemBase?.unitWidth ?? 0,
    //   unitHeight: dataItemBase?.unitHeight ?? 0,
    //   secondaryUomCode: dataItemBase?.secondaryUomCode ?? "",
    //   unitSellingPrice: dataItemBase?.unitSellingPrice ?? 0,
    //   longName: dataItemBase?.longName ?? "",
    //   warrantyDescrition: dataItemBase?.warrantyDescrition ?? "",
    //   sku: dataItemBase?.sku ?? "",
    //   onhandQuantyty: dataItemBase?.onhandQuantyty ?? 0,
    //   color: dataItemBase?.color ?? "",
    //   sex: dataItemBase?.sex ?? "",
    //   style: dataItemBase?.style ?? "",
    //   purpose: dataItemBase?.purpose ?? "",
    //   urlCanonical: dataItemBase?.urlCanonical ?? "",
    //   metaTitle: dataItemBase?.metaTitle ?? "",
    //   metaKeyword: dataItemBase?.metaKeyword ?? "",
    //   metaDescription: dataItemBase?.metaDescription ?? "",
    //   tag: dataItemBase?.tag ?? "",
    //   description: dataItemBase?.description ?? "",
    //   unitPriceReference: dataItemBase?.unitPriceReference ?? 0,
    //   brandId: dataItemBase?.brandId ?? 0,
    //   newStatus: dataItemBase?.newStatus ?? "",
    //   hotStatus: dataItemBase?.hotStatus ?? "",
    //   bestSaleStatus: dataItemBase?.bestSaleStatus ?? "",
    //   saleOffStatus: dataItemBase?.saleOffStatus ?? "",
    //   onlineStatus: dataItemBase?.onlineStatus ?? "",
    //   orderNumber: dataItemBase?.orderNumber ?? 0,
    //   itemSpec: dataItemBase?.itemSpec ?? "",
    //   url: dataItemBase?.url ?? "",
    //   itemSummary: dataItemBase?.itemSummary ?? "",
    //   videoUrl: dataItemBase?.videoUrl ?? "",
    // };

    const {
      view, // Trường không có trong ProductUpdateItem
      primaryImage, // Trường không có trong ProductUpdateItem
      ...restData
    } = dataItemBase || {}; //Cách này để loại bỏ các trường không có trong body gửi lên API
    const filteredData = restData as ProductUpdateItem;
    const dataSubmit: ProductUpdateItem = {
      ...filteredData,
      cssClassStatus: filteredData.cssClassStatus ?? "",
      attribute11: filteredData.attribute11 ?? 1,
      attribute12: filteredData.attribute12 ?? 1,
    };
    const allErrors = [
      ...validateField("itemName", dataItemBase?.itemName, dataItemBase),
      ...validateField("itemCode", dataItemBase?.itemCode, dataItemBase),
      ...validateField(
        "unitSellingPrice",
        dataItemBase?.unitSellingPrice,
        dataItemBase,
      ),
      ...validateField("marketPrice", dataItemBase?.marketPrice, dataItemBase),
      ...validateField("url", dataItemBase?.url, dataItemBase),
      ...validateField("brandId", dataItemBase?.brandId, dataItemBase),
      ...validateField("metaTitle", dataItemBase?.metaTitle, dataItemBase),
      ...validateField("metaKeyword", dataItemBase?.metaKeyword, dataItemBase),
      // ...validateField(
      //   "metaDescription",
      //   dataItemBase?.metaDescription,
      //   dataItemBase,
      // ),
    ];
    // console.log("allErrors", allErrors);
    // Cập nhật danh sách lỗi
    setDataListErrorValidate(allErrors);

    // Kiểm tra nếu có lỗi thì không cho submit form
    if (allErrors.length > 0) {
      return;
    }

    // Nếu không có lỗi thì mới submit form
    open();
    console.log("chạy vào đây");
    const response = await handleEditProductNew(dataSubmit);
    if (response && response.success) {
      NotificationExtension.Success("Cập nhật dữ liệu thành công");
    } else {
      NotificationExtension.Fails("Cập nhật dữ liệu thất bại");
    }
    close();
  };
  useEffect(() => {
    fetDataBrand();
  }, []);

  // Hàm để đếm số từ
  const countWords = (text: any) => {
    if (!text) return 0;
    const words = text.split(/\s+/).filter((word: any) => word !== "");
    return words.length;
  };

  // Hàm để đếm số kí tự
  const countCharacters = (text: any) => {
    return text ? text.length : 0;
  };

  // console.log("dataItemBase", dataItemBase);
  // console.log("dataListErrorValidate", dataListErrorValidate);
  const onNavigateOnWeb = () => {
    window.open(`${hacomUrl}/${dataItemBase?.url}`, "_blank");
  };
  return (
    <>
      <Box
        // className="flex-none"
        // miw={1300}
        // maw={1400}
        mx="10px"
        style={{ position: "relative" }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />
        <Flex justify={"space-between"} align={"center"}>
          <CopyButton value={String(dataItemBase?.itemName)} timeout={2000}>
            {({ copied, copy }) => (
              <Tooltip
                label={copied ? "Đã sao chép" : "Sao chép"}
                withArrow
                position="right"
              >
                <Badge
                  color={copied ? "teal" : "blue"}
                  onClick={copy}
                  style={{ cursor: "pointer" }}
                  size="lg"
                >
                  {dataItemBase?.itemName}
                </Badge>
              </Tooltip>
            )}
          </CopyButton>
          <Switch
            mt={"lg"}
            checked={
              dataItemBase?.attribute9 === "0" ||
                !dataItemBase?.attribute9 ||
                String(dataItemBase?.attribute9).length === 0
                ? false
                : true
            }
            label={"Sản phẩm mới lên web"}
            onChange={() =>
              handleChangeValue(
                dataItemBase?.attribute9 === "0" ? "1" : "0",
                "attribute9",
              )
            }
          />
        </Flex>
        <Group grow wrap="nowrap" gap={"lg"} align="start">
          <TextInput
            label={"Tên sản phẩm"}
            placeholder={"Tên sản phẩm"}
            required
            // disabled
            error={handleShowErrorValidate(
              "itemName",
              "Vui lòng nhập tên sản phẩm",
              dataListErrorValidate,
            )}
            withAsterisk
            type="text"
            value={dataItemBase?.itemName || ""}
            onChange={(e) => handleChangeValue(e.target.value, "itemName")}
          />
          <TextInput
            label={"Mã sản phẩm"}
            placeholder={"Mã sản phẩm"}
            error={handleShowErrorValidate(
              "itemCode",
              "Vui lòng nhập mã sản phẩm",
              dataListErrorValidate,
            )}
            disabled
            // withAsterisk
            type="text"
            value={dataItemBase?.itemCode || ""}
            onChange={(e) => handleChangeValue(e.target.value, "itemCode")}
          />
          <TextInput
            label={"Tên mô tả ngắn sản phẩm"}
            placeholder={"Tên ngắn sản phẩm"}
            type="text"
            value={dataItemBase?.shortName || ""}
            onChange={(e) => handleChangeValue(e.target.value, "shortName")}
          />
          <TextInput
            error={handleShowErrorValidate(
              "videoUrl",
              "Vui lòng nhập Link video sản phẩm",
              dataListErrorValidate,
            )}
            label={"Link video sản phẩm"}
            placeholder={"Video Url"}
            type="text"
            value={dataItemBase?.videoUrl || ""}
            onChange={(e) => handleChangeValue(e.target.value, "videoUrl")}
          />
        </Group>

        <Group grow wrap="nowrap" mt={"xl"} gap={"lg"} align="start">
          {/* <NumberInput
            label={"Giá bán"}
            placeholder={"Giá bán"}
            withAsterisk
            thousandSeparator=","
            error={handleShowErrorValidate(
              "unitSellingPrice",
              "Vui lòng nhập giá bán",
              dataListErrorValidate
            )}
            hideControls
            mt="md"
            value={dataItemBase?.unitSellingPrice || ""}
            onChange={(e) => handleChangeValue(e, "unitSellingPrice")}
          />
          <NumberInput
            label={"Giá thị trường"}
            withAsterisk
            thousandSeparator=","
            error={
              dataListErrorValidate?.includes("marketPriceInvalid")
                ? handleShowErrorValidate(
                    "marketPriceInvalid",
                    "Giá thị trường phải lớn hơn hoặc bằng giá bán",
                    dataListErrorValidate
                  )
                : handleShowErrorValidate(
                    "marketPrice",
                    "Vui lòng nhập giá thị trường",
                    dataListErrorValidate
                  )
            }
            placeholder={"Giá thị trường"}
            hideControls
            mt="md"
            value={dataItemBase?.marketPrice || ""}
            onChange={(e) => handleChangeValue(e, "marketPrice")}
          /> */}
          <TextInput
            label="Giá HSSV/Giá khoảng từ - đến"
            placeholder="Nhập giá HSSV/giá khoảng từ - đến"
            value={dataItemBase?.priceRangeDv || ""}
            onChange={(e) =>
              handleChangeValue(e.currentTarget.value, "priceRangeDv")
            }
          />
          <Select
            label={"Hiển thị"}
            placeholder={"Yes/No"}
            data={[
              { value: "Y", label: "Hiện" },
              { value: "N", label: "Ẩn" },
            ]}
            // readOnly
            // disabled
            value={dataItemBase?.inUse || ""}
            onChange={(e) => handleChangeValue(e, "inUse")}
          />
          <NumberInput
            label="Số thứ tự hiển thị"
            placeholder="Số thứ tự hiển thị"
            hideControls
            value={dataItemBase?.orderNumber || ""}
            onChange={(e) => handleChangeValue(e, "orderNumber")}
          />
          <Select
            error={handleShowErrorValidate(
              "brandId",
              "Vui lòng chọn thương hiệu",
              dataListErrorValidate,
            )}
            label="Chọn thương hiệu"
            placeholder="Thương hiệu"
            data={dataOptionBrand ? dataOptionBrand : []}
            value={dataItemBase?.brandId?.toString() || ""}
            searchable
            withAsterisk
            disabled
            readOnly
            onChange={(e: any) => handleChangeValue(Number(e), "brandId")}
          />

          {/* <Select
            error={handleShowErrorValidate(
              "sex",
              "Vui lòng chọn giới tính",
              dataListErrorValidate
            )}
            mt={"md"}
            label="Giới tính"
            placeholder="Nam/Nữ"
            data={["Nam", "Nu"]}
            value={dataItemBase?.sex || ""}
            searchable
            onChange={(e: any) => handleChangeValue(e, "sex")}
          /> */}
          <TextInput
            error={handleShowErrorValidate(
              "warrantyDescrition",
              "Vui lòng nhập thông tin bảo hành",
              dataListErrorValidate,
            )}
            label={"Thông tin bảo hành"}
            placeholder={"Thông tin bảo hành"}
            type="text"
            value={dataItemBase?.warrantyDescrition || ""}
            onChange={(e) =>
              handleChangeValue(e.target.value, "warrantyDescrition")
            }
          />
          {/* <Select
            label="Loại sản phẩm"
            placeholder="Chọn loại sản phẩm"
            data={[
              { value: "N", label: "Sản phẩm cũ" },
              { value: "Y", label: "Sản phẩm mới" },
            ]}
            value={dataItemBase?.newStatus ?? null}
            onChange={(value) => handleChangeValue(value, "newStatus")}
            clearable
            mt="md"
          /> */}
          <TextInput
            label={"HighlightClass"}
            placeholder={"Điền highlightClass cho sản phẩm"}
            type="text"
            value={dataItemBase?.cssClassStatus || ""}
            onChange={(e) =>
              handleChangeValue(e.target.value, "cssClassStatus")
            }
          />
        </Group>

        {/* <Group grow wrap="nowrap" mt="lg" gap={"lg"}> */}
        {/* <NumberInput
            label={"Giá vốn"}
            placeholder={"Giá vốn"}
            withAsterisk
            error={handleShowErrorValidate(
              "itemCost",
              "Vui lòng nhập giá vốn",
              dataListErrorValidate
            )}
            hideControls
            mt="md"
            value={dataItemBase?.itemCost || ""}
            onChange={(e) => handleChangeValue(e, "itemCost")}
          /> */}
        {/* </Group> */}
        <Textarea
          label="Note - Lưu ý"
          placeholder="Nhập lưu ý"
          value={dataItemBase?.attribute15 || ""}
          mt={"lg"}
          autosize
          minRows={4}
          onChange={(e) => handleChangeValue(e.target.value, "attribute15")}
        />

        <Text fw={700} size="lg" mt={"lg"}>
          Dùng cho SEO
        </Text>
        <Group grow wrap="nowrap" gap={"lg"} align="start">
          <TextInput
            error={handleShowErrorValidate(
              "url",
              "Vui lòng nhập Url index",
              dataListErrorValidate,
            )}
            label={"Url index"}
            placeholder={"url"}
            mt="sm"
            type="text"
            withAsterisk
            value={dataItemBase?.url || ""}
            onChange={(e) => {
              const rawValue = e.target.value;

              // Xử lý chuỗi thành dạng url chuẩn
              const formattedUrl = rawValue
                .toLowerCase() // Chuyển hết thành chữ thường
                .normalize("NFD") // Phân tách các ký tự có dấu thành các phần tử riêng biệt
                .replace(/[\u0300-\u036f]/g, "") // Loại bỏ các dấu (huyền, sắc, hỏi, ngã, nặng, mũ...)
                .replace(/đ/g, "d")
                .replace(/Đ/g, "d") // Xử lý riêng chữ đ và Đ
                .replace(/[^a-z0-9]/g, "-") // Thay thế khoảng trắng và tất cả các ký tự đặc biệt bằng dấu gạch ngang (-)
                .replace(/-+/g, "-") // Thu gọn nhiều dấu gạch ngang liên tiếp thành một dấu
                .replace(/^-+/, ""); // Xóa dấu gạch ngang nếu nó nằm ở ngay đầu chuỗi

              handleChangeValue(formattedUrl, "url");
            }}
          />
          <Group grow wrap="nowrap" gap={"lg"}>
            <Select
              mt={"sm"}
              label="Index"
              placeholder="Index/NoIndex"
              data={[
                { value: "1", label: "Index" },
                { value: "0", label: "NoIndex" },
              ]}
              value={dataItemBase?.attribute11 ?? "0"}
              searchable
              onChange={(e: any) => handleChangeValue(e, "attribute11")}
            />
            <Select
              mt={"sm"}
              label="Follow"
              placeholder="Follow/NoFollow"
              data={[
                { value: "1", label: "Follow" },
                { value: "0", label: "NoFollow" },
              ]}
              value={dataItemBase?.attribute12 ?? "0"}
              searchable
              onChange={(e: any) => handleChangeValue(e, "attribute12")}
            />
          </Group>
        </Group>
        <Group grow wrap="nowrap" mt="lg" gap={"lg"} align="start">
          <Box style={{ flex: 1 }}>
            <TextInput
              label={"Meta Title"}
              placeholder={"Meta Title"}
              withAsterisk
              error={handleShowErrorValidate(
                "metaTitle",
                "Vui lòng nhập Meta Title",
                dataListErrorValidate,
              )}
              mt="md"
              value={dataItemBase?.metaTitle || ""}
              onChange={(e) => handleChangeValue(e.target.value, "metaTitle")}
            />
            <Text size="sm" mt={5}>
              Số từ:{" "}
              <span style={{ fontWeight: 500 }}>
                {countWords(dataItemBase?.metaTitle)}
              </span>
              , Số ký tự:{" "}
              <span style={{ fontWeight: 500 }}>
                {countCharacters(dataItemBase?.metaTitle)}
              </span>
            </Text>
          </Box>

          <Box style={{ flex: 1 }}>
            <TextInput
              label={"Meta Keyword"}
              placeholder={"Meta Keyword"}
              withAsterisk
              error={handleShowErrorValidate(
                "metaKeyword",
                "Vui lòng nhập Meta Keyword",
                dataListErrorValidate,
              )}
              mt="md"
              value={dataItemBase?.metaKeyword || ""}
              onChange={(e) => handleChangeValue(e.target.value, "metaKeyword")}
            />
            <Text size="sm" mt={5}>
              Số từ:{" "}
              <span style={{ fontWeight: 500 }}>
                {countWords(dataItemBase?.metaKeyword)}
              </span>
              , Số ký tự:{" "}
              <span style={{ fontWeight: 500 }}>
                {countCharacters(dataItemBase?.metaKeyword)}
              </span>
            </Text>
          </Box>
        </Group>

        <Box>
          <Textarea
            label={"Meta Description"}
            placeholder={"Meta Description"}
            error={handleShowErrorValidate(
              "metaDescription",
              countCharacters(dataItemBase?.metaDescription) > 160
                ? "Meta Description quá dài !"
                : "",
              dataListErrorValidate,
            )}
            mt="md"
            autosize
            minRows={4}
            maxRows={6}
            value={dataItemBase?.metaDescription || ""}
            onChange={(e) =>
              handleChangeValue(e.target.value, "metaDescription")
            }
          />
          <Text size="sm" mt={5}>
            Số từ:{" "}
            <span style={{ fontWeight: 500 }}>
              {countWords(dataItemBase?.metaDescription)}
            </span>
            , Số ký tự:{" "}
            <span style={{ fontWeight: 500 }}>
              {countCharacters(dataItemBase?.metaDescription)}
            </span>
          </Text>
        </Box>

        <Group
          justify="flex-end"
          mt="lg"
          style={{
            position: "fixed",
            bottom: 10,
            right: 10,
            backgroundColor: "white",
          }}
        >
          <Button
            type="button"
            color="#3598dc"
            leftSection={<IconEyeSearch size={18} />}
            onClick={() => onNavigateOnWeb()}
          >
            Xem trên web
          </Button>
          <OpenProductTab
            productId={dataItemBase?.id}
            itemCode={dataItemBase?.itemName ?? ""}
            tabToOpen="info1"
            buttonText="Mở trang tab"
          />
          <Button
            type="button"
            color="#3598dc"
            onClick={(e) => {
              handleSubmitForm();
            }}
            leftSection={<IconCheck size={18} />}
          >
            Lưu
          </Button>
          <Button
            color="red"
            onClick={() => {
              navigate(-1);
            }}
            leftSection={<IconX size={18} />}
          >
            Đóng
          </Button>
        </Group>
      </Box>
    </>
  );
};

export default React.memo(ItemCommand);
